import PropTypes from 'prop-types';
import React from 'react';
import styles from '../InfoDialog.scss';
import CSSModules from "react-css-modules";
import SunbitDialog from "../../../components/common/material/Dialog";
import {FormattedMessage} from "react-intl";

@CSSModules(styles, {allowMultiple: true})
class IncomeInfoModal extends React.Component {

  constructor(props) {
    super(props);

  }

  render() {
    return <SunbitDialog dataAt={'incomeInfoModal'} theme={{dialog:styles.modalContainer}} active={this.props.isOpen}  onOverlayClick={this.props.handleAction}>
      <div styleName={'modalHeader'}>
        <div styleName={'dialogCloseIcon'}>
        <div data-at={'closeModalHeader'} styleName={'closeModalIcon'} onClick={this.props.handleAction}/>
        </div>
        <div data-at={'incomeInfoModalTitle'} styleName={'modalTitle'} >
          <FormattedMessage id={'atpUpdate.income.modal.title'}/>
        </div>
      </div>
      <div  data-at={'incomeInfoNodalContent'} styleName={'modalContent'}>
        <FormattedMessage id={'atpUpdate.income.modal.subtitle'}/>
        <div styleName={'infoList'}>
          <ul>
            <li><FormattedMessage id={'atpUpdate.income.modal.content.line1'}/></li>
            <li><FormattedMessage id={'atpUpdate.income.modal.content.line2'}/></li>
            <li><FormattedMessage id={'atpUpdate.income.modal.content.line3'}/></li>
            <li><FormattedMessage id={'atpUpdate.income.modal.content.line4'}/></li>
          </ul>
        </div>
      </div>
    </SunbitDialog>
  }

}

IncomeInfoModal.propTypes = {
  isOpen : PropTypes.bool,
  handleAction : PropTypes.func
};


export default IncomeInfoModal;



// WEBPACK FOOTER //
// ./src/card/CardDialogs/IncomeInfoDialog/IncomeInfoModal.js